import { useEffect } from "react";
import { fetchPublicCompanyProfile } from "@/services/companyProfile";
import { defaultFaviconUrl, setDocumentFavicon } from "@/utils/branding";

export default function SiteHead() {
  useEffect(() => {
    let alive = true;

    setDocumentFavicon(defaultFaviconUrl);
    fetchPublicCompanyProfile().then((profile) => {
      if (!alive) return;
      setDocumentFavicon(profile?.faviconUrl || defaultFaviconUrl);
    });

    return () => {
      alive = false;
    };
  }, []);

  return null;
}
